// extracted by mini-css-extract-plugin
module.exports = {"compareTip":"DefaultTimeline_compareTip__6smti","compareTipIcon":"DefaultTimeline_compareTipIcon__27L3Z","emptyState":"DefaultTimeline_emptyState__2vza3"};